import React, { useContext } from 'react'
import './carditems.css'
import { ShopContext } from '../../Context/ShopContext'
import remove_icon from '../Assets/cart_cross_icon.png'

export const CartItems = () => {
  
  const { getTotalCartAmount,all_product, cartItems, removeToCart } = useContext(ShopContext);
  
  return (
    <div className='cartitems'>
      {/* <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div> */}
      <hr />
      {all_product.map((e) => {
        if (cartItems[e.id] > 0) {
          return (
            <div className="carditems-format cartitems-format-main" key={e.id}>
              <div className="cartitem-image">
                <img src={e.image} alt={e.name} className='carticon-product-icon' />
              </div>
              <div className="cartitem-details">
                <p className='name'>Title - {e.name}</p>
                <p className='price'>Price - ${e.new_price}</p>
                Quantity - <button className='carditems-quanlity'> {cartItems[e.id]}</button>
                <p className='total'>Total - {e.new_price * cartItems[e.id]}</p>
              </div>
              <div className="cartitem-remove">
                <img className='cartitems-remove-icon'  src={remove_icon} onClick={() => removeToCart(e.id)} alt="" />
              </div>
            </div>
          );
        }
        return null;
      })}
      <hr />

      <div className="carditems-down">
        <div className="cartitems-total">
          <h1>Cart Totals</h1>
          <div>
            <div className="carditems-total-item">
              <p>Total</p>
              <p>${getTotalCartAmount()}</p>
            </div>
            <div className="carditems-total-item">
              <p>Promo Code</p>
              <input type="text" />
            </div>
          </div>
          <button className='btn'>PROCEED TO CHECKOUT</button>
        </div>
      </div>
      <hr />
    </div>
  );
}